// extracted by mini-css-extract-plugin
export default {"titleBox":"DocumentsTitle_titleBox__AkfaT"};